// Generic analytics store.
// На фронте мы НИЧЕГО не пишем сами во внешние трекеры. Каждый track() уходит
// единственным POST /api/analytics/track на наш бэк. Бэк сохраняет ивент и через
// зарегистрированные адаптеры выгружает во внешние системы.
//
// Адаптеры (опциональные) реализуют:
//   - install()                  — подгружают свои скрипты (mc.yandex.ru/metrika/tag.js и т.п.)
//                                  и делают capture своих параметров (yclid в localStorage).
//   - getContext() -> object|Promise<object>
//                                — opaque per-tracker identity снимок: { clientId, yclid, ... }.
//                                  Store на каждом track() собирает контексты от всех адаптеров
//                                  в payload.trackers — бэк апсертит их в Visitor.trackers
//                                  (last-touch attribution).

import $axios from '@martyrs/src/modules/core/views/utils/axios-instance.js';
import { reactive } from 'vue';

const state = reactive({
  clientAdapters: [],
});

async function collectTrackers(adapters = state.clientAdapters) {
  const out = {};
  for (const adapter of adapters) {
    if (typeof adapter.getContext !== 'function') continue;
    try {
      const ctx = await adapter.getContext();
      if (ctx && typeof ctx === 'object' && Object.keys(ctx).length) {
        out[adapter.name] = ctx;
      }
    } catch (e) {
      console.error(`[analytics] adapter "${adapter?.name}" getContext failed:`, e?.message);
    }
  }
  return out;
}

const actions = {
  install({ adapters = [] } = {}) {
    if (typeof window === 'undefined') return;
    state.clientAdapters = Array.isArray(adapters) ? adapters.filter(Boolean) : [];
    for (const adapter of state.clientAdapters) {
      try { adapter.install?.(); } catch (e) {
        console.error(`[analytics] adapter "${adapter?.name}" install failed:`, e?.message);
      }
    }
  },

  async track(name, params = {}) {
    if (typeof window === 'undefined') return;
    if (!name) return;
    const trackers = await collectTrackers(state.clientAdapters);
    try {
      await $axios.post('/api/analytics/track', { name, params: params || {}, trackers });
    } catch {
      // fire-and-forget — UI не блокируем
    }
  },

  // Снимок identity со ВСЕХ адаптеров ({ metrika: { clientId, yclid }, ga4: {...} }).
  // Нужен когда атрибуцию надо приложить к не-аналитическому запросу — например
  // в момент «Оплатить» положить clientId на сам платёж, чтобы server-side purchase
  // (webhook/reconcile, где браузера нет) знал, куда атрибутить конверсию.
  collectTrackers,
};

export { state, actions };
